import api from "Helpers/Api";
import { BannersListResponse, IBannerRequest } from "Services/Banners/banner";

export default async function bannerCreate(params: IBannerRequest) {
  const { data } = await api.post<BannersListResponse>(`/banners`, params);

  return data;
}
